let map;
let markers = [];

async function initMap() {
  const locations = window.GG_LOCATIONS || [];
  const mapConfig = window.GG_MAP_CONFIG || {};

  const mapEl = document.getElementById("map");
  const list = document.getElementById("locationsList");
  const mobileSelect = document.getElementById("mobileLocationSelect");

  if (!mapEl || !locations.length) return;

  const { Map, InfoWindow } = await google.maps.importLibrary("maps");
  const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

  map = new Map(mapEl, {
    center: { lat: 41.1, lng: -96.5 },
    zoom: 7,
    mapId: mapConfig.mapId,
    mapTypeControl: false,
    streetViewControl: false,
    fullscreenControl: true
  });

  const infoWindow = new InfoWindow();
  const bounds = new google.maps.LatLngBounds();

  function setActive(index) {
    markers.forEach((item, i) => {
      if (item.card) item.card.classList.toggle("is-active", i === index);
      item.markerEl.classList.toggle("is-active", i === index);
    });

    if (mobileSelect) {
      mobileSelect.value = String(index);
    }
  }

  function openLocation(index) {
    const loc = locations[index];
    const item = markers[index];
    if (!loc || !item) return;

    const lat = Number(loc.lat);
    const lng = Number(loc.lng);

    setActive(index);

    const storeButton = loc.storePage
      ? `<div style="margin-top:10px;"><a href="${loc.storePage}" style="color:#3F7C65;text-decoration:underline;">Store Info</a></div>`
      : "";

    infoWindow.setContent(`
      <div style="padding:6px 4px;font-family:Arial,sans-serif;line-height:1.45;">
        <strong>${loc.name || ""}</strong><br>
        ${loc.address1 || ""}<br>
        ${loc.cityStateZip || ""}
        ${loc.phone ? `<br>${loc.phone}` : ""}
        ${storeButton}
      </div>
    `);

    infoWindow.open({
      anchor: item.marker,
      map
    });

    map.panTo({ lat, lng });
    map.setZoom(13);
  }

  locations.forEach((loc, index) => {
    const lat = Number(loc.lat);
    const lng = Number(loc.lng);

    if (Number.isNaN(lat) || Number.isNaN(lng)) return;

    if (list) {
      const card = document.createElement("div");
      card.className = "location-card";
      card.innerHTML = `
        <h3>${loc.name || ""}</h3>
        <p>${loc.address1 || ""}<br>${loc.cityStateZip || ""}</p>
      `;
      card.addEventListener("click", () => openLocation(index));
      list.appendChild(card);
    }

    if (mobileSelect) {
      const option = document.createElement("option");
      option.value = String(index);
      option.textContent = loc.name || `Location ${index + 1}`;
      mobileSelect.appendChild(option);
    }

    const markerEl = document.createElement("div");
    markerEl.className = "gg-marker";
    markerEl.innerHTML = `
      <img
        src="${loc.markerIcon || "https://cdn.shopify.com/s/files/1/0048/7637/0018/files/MAP-ICON.png?v=1772822813"}"
        alt="${loc.name || ""}"
        class="gg-marker-icon"
      />
    `;

    const marker = new AdvancedMarkerElement({
      map,
      position: { lat, lng },
      title: loc.name || "",
      content: markerEl
    });

    marker.addListener("click", () => openLocation(index));

    markers.push({
      marker,
      markerEl,
      card: list ? list.children[list.children.length - 1] : null
    });

    bounds.extend({ lat, lng });
  });

  if (mobileSelect) {
    mobileSelect.addEventListener("change", (event) => {
      const index = event.target.value;
      if (index === "") return;
      openLocation(Number(index));
    });
  }

  if (!bounds.isEmpty()) {
    map.fitBounds(bounds);
  }
}

window.initMap = initMap;